import script from "./Bingli.vue?vue&type=script&setup=true&lang=js"
export * from "./Bingli.vue?vue&type=script&setup=true&lang=js"

import "./Bingli.vue?vue&type=style&index=0&id=0ee739a5&scoped=true&lang=css"

import exportComponent from "D:\\VSCODE_POJECT\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee739a5"]])

export default __exports__